import {
  ADMIN_DETAILS_RECEIVED,
  ADMIN_DETAILS_UNLOADED
} from './types'

export default function advisors(state = [], action = {}){
  switch (action.type) {
    case ADMIN_DETAILS_RECEIVED:
      return action.details 
    case ADMIN_DETAILS_UNLOADED:
      return {}
    default:
      return state;
  }
}